import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { IUserLogado } from "../../Services/Interfaces";
import { userServiceRescue } from "../../Services/User";
import {
  ICustomerService,
  IUserServiceRescueIOkRest,
  VitalSignsMeasurementsArray,
} from "../../Services/Interfaces";
import {
  RoundUp,
  intervalsRange,
  verificaTipoExternalId,
} from "../../utils/conversions";

function PageMeasurementThermal() {
  const { criteriaSrId } = useParams();
  const [userLogado, setUserLogado] = useState<IUserLogado>();
  const [vitalSignsMeasurements, setVitalSignsMeasurements] =
    useState<VitalSignsMeasurementsArray>();
  const [createdAt, setCreatedAt] = useState("");
  const [customerService, setCustomerService] = useState<ICustomerService>();

  useEffect(() => {
    const userJSON = localStorage.getItem("user");
    if (userJSON) {
      const userObjeto = JSON.parse(userJSON) as IUserLogado;
      setUserLogado(userObjeto);
    }
  }, []);

  useEffect(() => {
    if (criteriaSrId) {
      userServiceRescue(undefined, undefined, criteriaSrId).then((response) => {
        const { data } = response as IUserServiceRescueIOkRest;
        if (data.data.length > 0) {
          if (data.data[0].vitalSignsMeasurementsArray) {
            setVitalSignsMeasurements(data.data[0].vitalSignsMeasurementsArray);
            setCreatedAt(data.data[0].createdAt);
            setCustomerService(data.data[0].customerService);
          }
        }
      });
    }
  }, [criteriaSrId]);

  const formatThermalPrint = () => {
    if (!vitalSignsMeasurements || !userLogado || !customerService) return "";

    let output = "";
    const lineWidth = 80;
    const centerText = (text: string) => {
      const padding = Math.max(0, Math.floor((lineWidth - text.length) / 2));
      return " ".repeat(padding) + text;
    };

    // Cabeçalho
    output += "=".repeat(lineWidth) + "\n";
    output += centerText("PROGRAMA " + customerService.program.name.toUpperCase()) + "\n";
    output += "=".repeat(lineWidth) + "\n";
    output += centerText("RESULTADO DA MEDIÇÃO") + "\n";
    output += "-".repeat(lineWidth) + "\n";
    
    // Informações do usuário
    output += `Paciente: ${userLogado.profile.fullName}\n`;
    output += `Data: ${new Date(createdAt).toLocaleDateString()}\n`;
    output += `Hora: ${new Date(createdAt).toLocaleTimeString()}\n`;
    output += "-".repeat(lineWidth) + "\n";

    // SNR se disponível
    if (vitalSignsMeasurements["vazio"]) {
      const snrValue = verificaTipoExternalId("SNR", vitalSignsMeasurements["vazio"], 2);
      output += `SNR: ${snrValue}\n`;
      output += "-".repeat(lineWidth) + "\n";
    }

    // Medições por grupo
    Object.keys(vitalSignsMeasurements).forEach((key) => {
      if (key === "vazio") return;
      
      const measurements = vitalSignsMeasurements[key];
      if (measurements.length > 0) {
        output += centerText(measurements[0].displayGroup) + "\n";
        output += "-".repeat(lineWidth) + "\n";
        
        measurements.forEach((vitalSign) => {
          if (RoundUp(vitalSign.value, parseInt(vitalSign.presentation || "0")) === 0) {
            output += `${vitalSign.name}: Não medido\n`;
          } else {
            const value = RoundUp(vitalSign.value, parseInt(vitalSign.presentation || "0"));
            const unit = vitalSign.unit || "";
            output += `${vitalSign.name}: ${value} ${unit}\n`;
          }
        });
        output += "\n";
      }
    });

    // Rodapé
    output += "-".repeat(lineWidth) + "\n";
    output += centerText("ATENÇÃO!") + "\n";
    output += "Estes índices não deverão substituir a\n";
    output += "avaliação de um profissional de Saúde.\n";
    output += "São indicadores do programa\n";
    output += "de medição de bem-estar.\n";
    output += "=".repeat(lineWidth) + "\n";
    output += "\n\n\n"; // Espaço para cortar papel

    return output;
  };

  useEffect(() => {
    if (vitalSignsMeasurements && userLogado && customerService) {
      const thermalContent = formatThermalPrint();
      console.log("Conteúdo para impressora térmica:");
      console.log(thermalContent);

      const newWindow = window.open("", "_blank");
      if (newWindow) {
        newWindow.document.write(`
          <html>
            <head>
              <title>Impressão Térmica</title>
              <style>
                body { 
                  font-family: monospace; 
                  font-size: 12px; 
                  line-height: 1.2;
                  margin: 0;
                  padding: 10px;
                  white-space: pre;
                }
              </style>
            </head>
            <body>${thermalContent}</body>
          </html>
        `);
        newWindow.document.close();
        newWindow.print();
      }
    }
  }, [vitalSignsMeasurements, userLogado, customerService]);

  return (
    <div style={{ 
      fontFamily: 'monospace', 
      fontSize: '12px', 
      lineHeight: '1.2',
      whiteSpace: 'pre',
      padding: '20px',
      backgroundColor: '#f5f5f5'
    }}>
      {vitalSignsMeasurements && userLogado && customerService ? (
        <div>
          <h3>Visualização para Impressora Térmica (80 colunas)</h3>
          <div style={{ 
            backgroundColor: 'white', 
            padding: '20px', 
            border: '1px solid #ccc',
            fontFamily: 'monospace',
            fontSize: '10px'
          }}>
            {formatThermalPrint()}
          </div>
        </div>
      ) : (
        <div>Carregando dados para impressão térmica...</div>
      )}
    </div>
  );
}

export default PageMeasurementThermal; 